module.exports = __webpack_public_path__ + "img/back.8352e475.png";